import React from "react";
import { makeStyles, Typography, Container, Link } from "@material-ui/core";
import WeOffer from "./WeOffer";
import NtkButton from "../services/common/NtkButton";
import WeOfferSlider from "./WeOfferSlider";
import allOffer from "./offerData.js";

const useStyles = makeStyles((theme) => ({
  allOffers: {
    position: "relative",
    overflow: "hidden",
    width: "100%",
    height: "400px",
    marginTop: "5%",
    padding: "5%",
    [theme.breakpoints.down("sm")]: {
      height: "600px",
      position: "static",
    },
  },
  slider: {
    width: "100%",
    height: "300px",
  },
  box: {
    width: "250px",
    position: "absolute",
    top: "15%",
    right: "40%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    [theme.breakpoints.down("sm")]: {
      position: "static",
      margin: "0 auto",
    },
  },
  root: {
    margin: "3em 0em 1em 0em",
  },
  offerImg: {
    maxWidth: "100%",
    maxHeight: "100%",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    height: "90px",
    width: "160px",
    borderRadius: "8px",
  },
  spaces: {
    marginBottom: "2em",
  },
  spacesHeader: {
    marginBottom: "20px",
  },
  spacesBtn: {
    marginTop: "3em",
  },
  hide: {
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  show: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
}));
const Offers = () => {
  const classes = useStyles();
  return (
    <>
      <Container maxWidth="lg" className={classes.allOffers}>
        <section className={classes.hide}>
          {allOffer.slice(1).map((offer) => {
            return (
              <WeOffer
                key={offer.title}
                image={offer.image}
                title={offer.title}
                top={offer.top}
                right={offer.right}
              />
            );
          })}
        </section>
        <Container
          maxWidth="sm"
          className={`${classes.slider} ${classes.show}`}
        >
          <WeOfferSlider offers={allOffer} />
        </Container>
        <div className={classes.box}>
          <div
            className={`${classes.offerImg} ${classes.hide}`}
            style={{ backgroundImage: `url(${allOffer[0].image})` }}
          ></div>
          <div className={classes.root}>
            <Typography
              gutterBottom
              variant="h3"
              color="primary"
              className={classes.spacesHeader}
            >
              We offer a wide range of language options
            </Typography>
            <Typography
              variant="subtitle2"
              color="secondary"
              className={classes.spaces}
            >
              ARABIC | FRENCH | SPANISH | PERSIAN
            </Typography>
            <Typography
              variant="subtitle2"
              color="secondary"
              className={classes.spaces}
            >
              Classes start at $13 / hour
            </Typography>
            <Link href={"/shop"} style={{ textDecoration: "none" }}>
              <NtkButton title={"Offers"} className={classes.spacesBtn} />
            </Link>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Offers;
